module.exports = __webpack_public_path__ + "assets/badge-module-5.b16bda27b3c2090fc255199e3be2ccd1.svg";